import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Client } from 'core/models/client';
import { Subscription } from 'core/models/subscription';

@Component({
  selector: 'lms-credit-create',
  templateUrl: './credit-create.component.html',
  styleUrls: ['./credit-create.component.scss']
})
export class CreditCreateComponent implements OnInit, OnDestroy {
  public routeSubscription: any;
  public client: Client;

  constructor(
    public location: Location,
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public titleService: Title
  ) {}

  ngOnInit() {
    this.routeSubscription = this.route.data.subscribe((data) => {
      this.client = data['client'];
      this.titleService.setTitle(
        this.translate.instant('credits.create') +
          ' - ' +
          this.translate.instant('pageTitle.clients') +
          ' - ' +
          this.translate.instant('pageTitle.gamelearn')
      );
    });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  onSave(creditsBag: Subscription) {
    this.location.back();
  }

  cancel() {
    this.location.back();
  }
}
